import { render, staticRenderFns } from "./transferUser.vue?vue&type=template&id=9b6a0e38&scoped=true"
import script from "./transferUser.vue?vue&type=script&lang=js"
export * from "./transferUser.vue?vue&type=script&lang=js"
import style0 from "./transferUser.vue?vue&type=style&index=0&id=9b6a0e38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a0e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b6a0e38')) {
      api.createRecord('9b6a0e38', component.options)
    } else {
      api.reload('9b6a0e38', component.options)
    }
    module.hot.accept("./transferUser.vue?vue&type=template&id=9b6a0e38&scoped=true", function () {
      api.rerender('9b6a0e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/myTask/transferUser.vue"
export default component.exports